import {
    SHOW_CONFIRM,
    HIDE_CONFIRM,
} from '../actions/types';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_CONFIRM:
            return action.payload;
        case HIDE_CONFIRM:
            return INITIAL_STATE;
        default:
            return state;
    }
};
